import { API_URL, AUTH_LEXON_PARTNER_ID, LEXON_PARTNER_ID } from '@/general/config'
import { AxiosRequestConfig } from 'axios'

export const securityHeaders = {
  'Strict-Transport-Security': 'max-age=31536000; includeSubDomains',
  'Content-Security-Policy': 'script-src "self"',
  'X-Frame-Options': 'DENY',
  'X-Content-Type-Options': 'nosniff',
  'Referrer-Policy': 'strict-origin-when-cross-origin',
  'Permissions-Policy': `geolocation=(self "${API_URL}")`,
  'Cross-Origin-Embedder-Policy': 'require-corp',
  'Cross-Origin-Opener-Policy': 'same-origin-allow-popups',
  'Clear-Site-Data': '"cookies", "cache"',
  'X-Permitted-Cross-Domain-Policies': 'none',
  'Cache-Control': 'no-store, no-cache, must-revalidate, proxy-revalidate'
}

export const axiosConfiguration: AxiosRequestConfig = {
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    [AUTH_LEXON_PARTNER_ID]: LEXON_PARTNER_ID,
    'Content-Type': 'application/x-www-form-urlencoded',
    Accept: 'application/json',
    ...securityHeaders
  }
}
